import React from 'react'
import { useEffect, useState } from 'react'

interface TabsPageProps {
	metadataId?: number
}

export const TabsPage = () => {
	const [count, setCount] = useState(0)

	return <button onClick={() => setCount(count + 1)}> 这是Hook组件 {count}</button>
}



// WEBPACK FOOTER //
// ./src/modules/modeling/components/TabsPageMould.tsx